import adminHttp from "@/api/adminHttp";

export default {
    generateFirstStage: (stageId, params) => adminHttp.post(`/api/v1/admin/tournament/grid-generate/${stageId}`, params),
    generateNextStage: (stageId) => adminHttp.post(`/api/v1/admin/tournament/grid-generate/next-stage/${stageId}`),
    getGrid: (stageId) => adminHttp.get(`/api/v1/client/tournament/mlbb/grid/stage/${stageId}`),
    // Добавление команды в группу (double elimination)
    addTeamToGroup: (groupId, teamId) => adminHttp.post(`/api/v1/admin/tournament/groups/${groupId}/teams/${teamId}`),
    // Удаление команды из группы (double elimination)
    deleteTeamFromGroup: (groupId, teamId) => adminHttp.delete(`/api/v1/admin/tournament/groups/${groupId}/teams/${teamId}`),
    // Получение проигравших команд (double elimination)
    getLosingTeams: (stageId, params) => adminHttp.post(`/api/v1/admin/tournament/stages/${stageId}/losing-teams`, params),
    // Запуск автоматизации матча MLBB
    startMlbbAutomation: (groupId) => adminHttp.post(`/api/v1/admin/mlbb/automation/groups/${groupId}/start`),
    // Получение данных запущенного автоматизированного матча MLBB
    getMlbbMatch: (groupId) => adminHttp.get(`/api/v1/client/mlbb/matches/${groupId}`),
    // Установка таймера фазы автоматизации MLBB (phase: 1 = чек-ин, 2 = лобби; minutes: 1..120)
    setMlbbAutomationTimer: (automationId, params) => adminHttp.post(`/api/v1/admin/mlbb/automation/${automationId}/timer`, params),
    // Принудительное одобрение рехоста (сброс лобби и генерация новых ссылок)
    approveMlbbRehost: (automationId) => adminHttp.post(`/api/v1/admin/mlbb/automation/${automationId}/rehost/approve`),
    // Ручное назначение победителя и продвижение по сетке (is_wo — опционально для ТП)
    advanceMlbbAutomation: (automationId, params, config) => adminHttp.post(`/api/v1/admin/mlbb/automation/${automationId}/advance`, params, config),
    // Снятие алерта автоматизации MLBB
    resolveMlbbAlert: (alertId) => adminHttp.post(`/api/v1/admin/mlbb/automation/alerts/${alertId}/resolve`)
}